<div class="server-settings-root">
	<h1 style="margin-bottom: 20px;">Slack Settings</h1>
	<form [formGroup]="form">
		<div [ngClass]="{'has-error':form.hasError('noneOrAllSettings') && !webhooks.value}">
			<span class="col-lg-2">Webhook URLs:</span>
			<div class="col-lg-5">
				<textarea [formControl]="webhooks" rows="5" cols="100" placeholder="Paste your URLs here"></textarea>
			</div>
		</div>
		<div class="slack-default-settings-divider"></div>
		<div class="row" style="padding-top: 10px;">
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="onSave()" [disabled]="!form.dirty" label="Save Slack Default Settings"></button>
			</div>
			<div style="height: 21px; width: 250px;">
				<button pButton (click)="testConnection()" [disabled]="!enableTestSlackButton" title="Test/Verify Slack connection" label="Test Slack"></button>
			</div>
		</div>
		<div class="slack-default-settings-divider"></div>
	</form>
</div>